export enum FeatureType {
  Admin = 'access-rocketmaster-feature',
  AutoExport = 'access-autoexport-feature',
  Permissions = 'access-permissions-feature',
  LoadManagement = 'access-load-management-feature',
  Reports = 'access-reports-feature',
  StationMaintenance = 'access-station-maintenance-feature',
  Hubject = 'access-hubject-feature',
  PricePlans = 'access-price-plans-feature',
  /**
   * Not a permission: the backend adds it while the CardTerminals feature flag is on for the user and the user has a
   * Premium or Gold Partner license.
   */
  CardTerminals = 'access-card-terminals-feature',
  /**
   * Not a permission: the backend adds it while the CardTerminals feature flag is on for the user. Shows the menu
   * entry, which leads to the license information until the user is licensed.
   */
  CardTerminalsRollout = 'card-terminals-rollout-feature',
}

export enum MenuType {
  Static = 'link',
  Expandable = 'sub',
  separator = 'separator',
}

export class Menu {
  state: string;
  name: string;
  icon: string;
  separator?: Menu;
  type: MenuType;
  children?: Menu[];
  requiredFeatures?: FeatureType[];
}
